import { components } from "src/strapi/schema";
import React, { useState } from "react";
import { cn } from "src/lib/utils";
import { Button } from "src/components/ui/button";
import { ChevronSharpRight } from "src/components/ui/icons/ChevronSharpRight";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/components/ui/tooltip";
import { Link } from "@tanstack/react-router";

type NavbarDropdownNavItemProps = {
  dropdown: components["schemas"]["UiDropdownComponent"];
  onNavigate: () => void;
};

export const NavbarDropdownNavItem: React.FC<NavbarDropdownNavItemProps> = ({
  dropdown,
  onNavigate,
}) => {
  const [isOpenOnMobile, setIsOpenOnMobile] = useState(false);

  return (
    <>
      <div className={"w-full xl:hidden"}>
        <div className={"flex w-full items-center justify-between"}>
          <Button
            asChild
            variant={"link"}
            size={"default"}
            className={cn(
              "flex w-3/4 justify-start text-lg font-semibold tracking-wide uppercase",
            )}
          >
            <Link to={dropdown.rootButton?.link ?? ""} onClick={onNavigate}>
              {dropdown.rootButton?.text}
            </Link>
          </Button>
          <div
            className={"flex w-1/4 cursor-pointer justify-center py-2"}
            onClick={() => {
              setIsOpenOnMobile(!isOpenOnMobile);
            }}
          >
            <ChevronSharpRight
              strokeWidth={3.5}
              className={cn("size-4 rotate-90 transition-all", {
                "-rotate-90": isOpenOnMobile,
              })}
            />
          </div>
        </div>
        {isOpenOnMobile && (
          <ul className="divide-border/20 flex flex-col divide-y">
            {dropdown.dropdownButtons?.map((item) => (
              <li key={item.text} className={"ml-4 py-2"}>
                <Button
                  asChild
                  variant={item.variant}
                  size={item.size}
                  className={cn("w-full justify-start text-lg uppercase")}
                >
                  <Link to={item.link ?? ""} onClick={onNavigate}>
                    {item.text ?? "Unknown link"}
                  </Link>
                </Button>
              </li>
            ))}
          </ul>
        )}
      </div>

      <div className={"hidden xl:block"}>
        <TooltipProvider skipDelayDuration={0} delayDuration={0}>
          <Tooltip delayDuration={0}>
            <TooltipTrigger
              className={
                "px-10 outline-none focus-visible:outline-none xl:px-0"
              }
            >
              <Button
                asChild
                variant={"link"}
                size={"default"}
                className={cn(
                  "flex w-full gap-2 text-lg font-semibold tracking-wide uppercase",
                )}
              >
                <Link to={dropdown.rootButton?.link ?? ""} onClick={onNavigate}>
                  <span>{dropdown.rootButton?.text}</span>
                  <ChevronSharpRight
                    strokeWidth={3.5}
                    className={cn("rotate-90 transition-all", {
                      "-rotate-90": isOpenOnMobile,
                    })}
                  />
                </Link>
              </Button>
            </TooltipTrigger>

            <TooltipContent
              className={cn(
                "overscroll-y-hidden bg-foreground text-background rounded-none border-none p-1 outline-none",
              )}
            >
              <ul className="divide-border/20 flex flex-col divide-y">
                {dropdown.dropdownButtons?.map((item) => (
                  <li key={item.text} className={"py-2"}>
                    <Button
                      asChild
                      variant={item.variant}
                      size={item.size}
                      className={cn("w-full justify-start text-lg uppercase")}
                    >
                      <Link to={item.link ?? ""} onClick={onNavigate}>
                        {item.text ?? "Unknown link"}
                      </Link>
                    </Button>
                  </li>
                ))}
              </ul>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </>
  );
};
